<template>
  <div class="container jackpot" data-aos="slide-up" data-aos-duration="10000">
    <div class="d-flex jackpot-content">
      <div class="jackpot-heading">
        <h1>Crea un pseudocódigo práctico y entendible en idioma Kichwa</h1>
      </div>
      <div class="jackpot-text">
        <p>
          El crecimiento y los cambios tecnológicos demandan el desarrollo de nuevas y variadas
          habilidades y conocimientos para analizar y resolver problemas.
        </p>
      </div>
    </div>
    <div class="jackpot-list d-flex">
      <div class="jackpot-info">
        <div class="icon-background icon-padding">
          <IconComponent name="bill" />
        </div>
        <div>
          <h2 class="red">
            Capacitar
          </h2>
          <p>
            apoyar al proceso enseñanza-aprendizaje de programacion para personas Kichwa Hablantes
          </p>
        </div>
      </div>
      <div class="jackpot-info">
        <div class="icon-background icon-padding">
          <IconComponent name="network" />
        </div>
        <div>
          <h2 class="blue">
            Cerrar Brechas
          </h2>
          <p>
              Mediante una plataforma con contenido en Kichwa
          </p>
        </div>
      </div>
      <div class="jackpot-info">
        <div class="icon-background icon-padding">
          <IconComponent name="badge" />
        </div>
        <div>
          <h2 class="green">
            Ser el primer paso
          </h2>
          <p>
            Incentivar el desarrollo de soluciones que permitan compartir conocimientos evitando que el idioma se un impedimento
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "./IconComponent";

export default {
  components: {
    IconComponent
  }
};
</script>
